import { Link } from 'react-router-dom';
import { useState } from 'react';

const faqs = [
  {
    q: 'Was ist ein OOPBuy Spreadsheet?',
    a: 'Ein OOPBuy Spreadsheet ist eine kuratierte Tabelle mit Produktlinks zu den besten Angeboten auf kaspreadsheet.com. Sie sind nach Kategorien sortiert und werden regelmäßig aktualisiert.',
  },
  {
    q: 'Sind die Spreadsheets kostenlos?',
    a: 'Ja, alle Spreadsheets sind komplett kostenlos nutzbar. Du brauchst nur einen Account auf kaspreadsheet.com, um zu bestellen.',
  },
  {
    q: 'Wie aktuell sind die Spreadsheets?',
    a: 'Die Spreadsheets werden wöchentlich aktualisiert. Neue Produkte kommen hinzu, nicht verfügbare werden entfernt.',
  },
  {
    q: 'Ist der Einkauf sicher?',
    a: 'Absolut. Alle Links führen zu kaspreadsheet.com, einer etablierten Plattform mit Käuferschutz und sicheren Zahlungsmethoden.',
  },
  {
    q: 'Versendet ihr auch nach Österreich und in die Schweiz?',
    a: 'Ja, der Versand erfolgt nach Deutschland, Österreich und in die Schweiz. Die Lieferzeiten variieren je nach Land.',
  },
  {
    q: 'Wie finde ich das richtige Produkt?',
    a: 'Nutze die Kategorien-Navigation oder unsere ausführlichen Guides. Jedes Spreadsheet enthält detaillierte Produktinformationen.',
  },
  {
    q: 'Gibt es eine Geld-zurück-Garantie?',
    a: 'kaspreadsheet.com bietet einen Käuferschutz für die meisten Bestellungen. Die genauen Bedingungen findest du auf der Plattform.',
  },
  {
    q: 'Kann ich mehrere Produkte aus verschiedenen Spreadsheets kombinieren?',
    a: 'Ja! Du kannst frei zwischen allen Spreadsheets wechseln und Produkte nach deinen Wünschen kombinieren.',
  },
];

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-foreground-100 text-foreground-600 text-xs font-medium mb-3">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Häufig gestellte Fragen
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            Alles, was du über OOPBuy Spreadsheets wissen musst – kurz und verständlich erklärt.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                className="border border-background-200/80 rounded-xl overflow-hidden bg-background-50"
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-xs text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-6">
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            <span>Mehr erfahren im vollständigen Guide</span>
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}